// src/pages/FriendshipVibeHomePage.jsx - Complete Friendship Vibe Landing Page
import React from 'react';
import { useApp } from '../context/AppContext';
import FriendshipVibeHero from '../components/friendship/FriendshipVibeHero';
import FriendshipVibeFeatures from '../components/friendship/FriendshipVibeFeatures';
import FriendshipVibeHowItWorks from '../components/friendship/FriendshipVibeHowItWorks';
import MeetYourGuideSection from '../components/friendship/MeetYourGuideSection';
import FriendshipVibeAssessmentPreview from '../components/friendship/FriendshipVibeAssessmentPreview';
import FriendshipModulesPreview from '../components/friendship/FriendshipModulesPreview';
import FriendshipVibeToolsPreview from '../components/home/FriendshipVibeToolsPreview';
import FriendCirclesPromo from '../components/friendship/FriendCirclesPromo';
// import FriendshipVibePrivacyPromise from '../components/friendship/FriendshipVibePrivacyPromise';
// import FriendshipVibeCTA from '../components/friendship/FriendshipVibeCTA';

const FriendshipVibeHomePage = () => {
  const { setCurrentView } = useApp();
  
  // Module data for preview carousel
  const modulesData = [
    {
      id: 1,
      title: 'Squad Dynamics 101',
      subtitle: 'Understanding your friend ecosystem',
      description: 'Decode the hidden dynamics in your friend group and learn why certain patterns keep repeating.',
      level: 'Foundation',
      series: 'Core Skills',
      duration: '10 minutes',
      coolFactor: 'Like X-ray vision for friend groups',
      image: '/images/squad-dynamics-mod01.png',
      imageAlt: 'Diverse friend group illustration showing different friendship dynamics',
    },
    {
      id: 2,
      title: 'Boundary Boss Mode',
      subtitle: 'Set limits without losing friends',
      description: 'Master the art of saying no without guilt and create boundaries that actually strengthen friendships.',
      level: 'Foundation',
      series: 'Core Skills',
      duration: '12 minutes',
      coolFactor: 'Boundaries but make them kind',
      image: '/images/boundary-boss-mod02.png',
      imageAlt: 'Person confidently setting healthy boundaries',
    },
    {
      id: 3,
      title: 'The Drama Decoder',
      subtitle: 'Navigate conflict like a pro',
      description: 'Transform from drama magnet to conflict navigator. Learn to handle friendship tensions without losing your mind.',
      level: 'Essential',
      series: 'Conflict Skills',
      duration: '15 minutes',
      coolFactor: 'Drama prevention toolkit',
      image: '/images/drama-decoder-mod03.png',
      imageAlt: 'Calm person navigating friendship conflict',
    },
    {
      id: 4,
      title: 'Energy Management HQ',
      subtitle: 'Protect your social battery',
      description: 'Identify energy vampires, find your recharge rituals, and balance social time with solo time like a pro.',
      level: 'Essential',
      series: 'Self-Care',
      duration: '10 minutes',
      coolFactor: 'Social battery optimisation',
      image: '/images/energy-management-mod04.png',
      imageAlt: 'Person managing their social energy wisely',
    },
    // Add more as images are created
  ];
  
  const handleModuleClick = (module) => {
    setCurrentView('friendship-modules');
  };

  // Friend Circles' own router sends a signed-out visitor to the circles
  // landing page, someone with circles to their circle, and anyone else to
  // set one up.
  const handleJoinCircle = () => {
    setCurrentView('friend-circles');
  };

  return (
    <div className="min-h-screen bg-slate-900">
      {/* Hero Section */}
      <FriendshipVibeHero />

      {/* What This App Offers */}
      <FriendshipVibeFeatures />

      {/* How It Works */}
      <FriendshipVibeHowItWorks />

      {/* Meet Your Guide */}
      <MeetYourGuideSection />

      {/* Assessment Preview */}
      <FriendshipVibeAssessmentPreview />

      {/* Modules Preview */}
      <FriendshipModulesPreview />

      {/* Interactive Tools Preview */}
      <FriendshipVibeToolsPreview setCurrentView={setCurrentView} />

      {/* Friend Circles Promotional Section */}
      <FriendCirclesPromo onJoinClick={handleJoinCircle} />

      {/* Privacy Promise - Component not created yet */}
      {/* <FriendshipVibePrivacyPromise /> */}

      {/* Final CTA - Component not created yet */}
      {/* <FriendshipVibeCTA /> */}
    </div>
  );
};

export default FriendshipVibeHomePage;